// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
var _ = require('lodash');
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { browserHistory as history } from 'react-router';
import {
  unloadDashboard, searchSuggestions, navActivate,
  selectIndex, showUtilization, updateDateRange
} from '../../actions/actions';

import constants from '../../Constants';
import messages from '../../Messages';
import Article from 'grommet/components/Article';
import Header from 'grommet/components/Header';
import Headline from 'grommet/components/Headline';
import Section from 'grommet/components/Section';
import Search from 'grommet/components/Search';
import Title from 'grommet/components/Title';
import Tile from 'grommet/components/Tile';
import Box from 'grommet/components/Box';
import FormField from 'grommet/components/FormField';
import DateTime from 'grommet/components/DateTime';
import Form from 'grommet/components/Form';
// import Label from 'grommet/components/Label';
import Value from 'grommet/components/Value';
import Select from 'grommet/components/Select';
import Button from 'grommet/components/Button';
import Sidebar from 'grommet/components/Sidebar';
import Split from 'grommet/components/Split';
import CheckBox from 'grommet/components/CheckBox';
import CaretBackIcon from 'grommet/components/icons/base/CaretBack';
import Heading from 'grommet/components/Heading';
import Layer from 'grommet/components/Layer';
import MenuIcon from 'grommet/components/icons/base/Menu';

import NavControl from '../NavControl';
import ChartView from './ChartView';
import SideMenu from './SideMenu';
import Plans from './Plans';
import { navEnable } from '../../actions/nav';
import { getDateFromDateRange,convertDate } from '../../utils/Utility';

// import  from 'grommet/components/Base';
// import Chart, { Layers, Base, Axis, Grid, Area, Bar, Line, Marker, MarkerLabel, HotSpots } from 'grommet/components/chart/Chart';
import {
  loadTwigs, changeTwig, loadChartData, updateFromDate, updateToDate, changeResolution, updateSelectedTwig, getUserPreferencesAction,
  saveUserPreferencesAction,getPageLoadData
} from '../../actions/locationView';
import { showLoader } from '../../actions/status';
let dateRangeValue = constants.DATE_RANGE.TWO_WEEKS;
class LocationView extends Component {

  constructor(props) {
    super(props);

    this._onStartDateChange = this._onStartDateChange.bind(this);
    this._onToDateChange = this._onToDateChange.bind(this);
    this._updateChart = this._updateChart.bind(this);
    this._selectTwig = this._selectTwig.bind(this);
    this._dateRangeSelectChange = this._dateRangeSelectChange.bind(this);
    this.getOrientation = this.getOrientation.bind(this);
    this.onTwigChange = this.onTwigChange.bind(this);
    this.setControlData = this.setControlData.bind(this);
    this._manageLocationView = this._manageLocationView.bind(this);
    this.showSideMenu = this.showSideMenu.bind(this);
    this._onResponsive = this._onResponsive.bind(this);

    this._setDocumentTitle(props);
    this.state = {
      selectedTwigIndex: 0,
      dateRangeValue: constants.DATE_RANGE.TWO_WEEKS,
      directionForHeader: 'row',
      chosenTwig: '-1',
      dateRange: { Type: constants.DATE_RANGE.NONE, FromDate: 'empty', ToDate: 'empty' },
      stripePlans: null,
      stripeAPIKey: "",
      showLayer: false,
    };
  }

  componentWillMount() {
    this.props.dispatch(navEnable(false));
    this.props.dispatch(getPageLoadData(this.props.selectedTwig));
  }


  // componentWillMount() {
  //   this.props.dispatch(navEnable(false));
  //   if (this.props.location.state) {
  //     // siteName = decodeURIComponent(this.props.location.query.name);
  //     if (this.props.twigsList.length <= 0) {
  //       // this.setState({
  //       //   twigsList: this.props.location.state.twigsList
  //       // })
  //       this.props.dispatch(loadTwigs(true, '', 0));
  //     } else {
  //       let fromDate = new Date();
  //       fromDate.setDate(fromDate.getDate() - 14);
  //       let toDate = new Date();
  //       this.props.dispatch(loadChartData(this.props.location.state.twigId, fromDate.toISOString(), toDate.toISOString(), ''))
  //     }


  //   } else {
  //     this.props.dispatch(loadTwigs(true, '', 0));
  //   }
  //   this.getUserPreference();
  // }


  componentDidMount() {
    //  this.props.dispatch(showLoader(true));
    if (this.props.location.state) {
      this.refs.selectedTwigIndex.value = this.props.location.state.selectedTwigIndex
    }
    window.addEventListener("resize", () => {
      this.getOrientation();
    });
  }


  componentDidUpdate() {

  }

  componentWillReceiveProps(nextProps) {
    // this.props.userPreferences.twigId = "0xffffffffffffffff";
    // this._setDocumentTitle(nextProps);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => {
      this.getOrientation();
    });
    this.saveUserPreference()
  }

  saveUserPreference() {
    let userPreferenceObj = {
      zoom: this.props.zoom,
      sensors: this.props.chartOptions.displayOptions,
      depth: this.props.chartOptions.depth,
      dataModel: {
        raw: this.props.showRawGraph,
        trend: this.props.showTrendLine,
        trendAverage:this.props.trendAverage
      },
      limits: {
        upper: this.props.showUpperLimit,
        lower: this.props.showLowerLimit
      },
      stem: this.props.selectedTwig.twigId,
      fromDate: this.props.chartOptions.fromDate,
      toDate: this.props.chartOptions.toDate,
      dateRange: this.props.chartOptions.dateRange,
      selectedTwig:this.props.selectedTwig
    }
    this.props.dispatch(saveUserPreferencesAction(userPreferenceObj));
  }

  getOrientation() {
    var orientation = window.innerWidth > window.innerHeight ? "Landscape" : "Portrait";
    this.setState({
      directionForHeader: orientation == 'Landscape' ? 'row' : 'column'
    })
  }

  _setDocumentTitle(props) {
    document.title = 'Dashboard ';
  }

  _manageLocationView() {
    return this.props.showStripePlans ? <Plans /> : <ChartView />;
  }

  _onToDateChange(date) {

    let today = new Date();
    let selectedDate = new Date(date);
    if (selectedDate <= today) {
      if (this.props.chartOptions.fromDate) {
        if (selectedDate < new Date(this.props.chartOptions.fromDate)) {
          alert(messages.DATEFILTER.INVALID_TODATE);
        }
        else {
          let toDate = selectedDate.getTime();
          let dateRange = this.state.dateRange;
          dateRange.ToDate = date;
          dateRange.Type = constants.DATE_RANGE.CUSTOM;
          this.setState({ dateRange: dateRange });
          // let fromDate = new Date(this.props.chartOptions.fromDate).getTime();
          this.props.dispatch(updateToDate(date));
          this.refs.dateRange.value = constants.DATE_RANGE.CUSTOM;
          // setTimeout(() => {
          //   this.props.dispatch(loadChartData(this.props.selectedTwig.twigId, fromDate, toDate, ''))
          // }, 100)
        }
      } else {
        alert(messages.DATEFILTER.SELECT_STARTDATE)
      }

    } else {
      alert(messages.DATEFILTER.FUTURE_DATE)
    }

  }

  _onStartDateChange(date) {

    let today = new Date();
    let selectedDate = new Date(date);
    if (selectedDate <= today) {
      if (selectedDate > new Date(this.props.chartOptions.toDate)) {
        alert(messages.DATEFILTER.INVALID_FROMDATE);
      }
      else {
        let fromDate = selectedDate.getTime();
        // let toDate = new Date(this.props.chartOptions.toDate).getTime();
        this.props.dispatch(updateFromDate(date));
        this.refs.dateRange.value = constants.DATE_RANGE.CUSTOM;
        let dateRange = this.state.dateRange;
        dateRange.Type = constants.DATE_RANGE.CUSTOM;
        dateRange.FromDate = date;
        this.setState({ dateRange: dateRange });
        // setTimeout(() => {
        //   this.props.dispatch(loadChartData(this.props.selectedTwig.twigId, fromDate, toDate, ''))
        // }, 100)
      }
    } else {
      alert(messages.DATEFILTER.FUTURE_DATE)
    }
  }

  _updateChart(e) {
    let twigIndx = this.refs.selectedTwigIndex.value;
    let timeOutValue = 0;
    if (this.props.twigsList[twigIndx].twigId != this.props.selectedTwig.twigId) {
      timeOutValue = 1;
      this.props.dispatch(updateSelectedTwig(this.refs.selectedTwigIndex.value));
    }
    setTimeout(() => {
      // console.log('this.props.chartOptions::', this.props.chartOptions);
      // console.log('this.refs.dateRange::', this.refs.dateRange.value)
      if (this.refs.dateRange.value == constants.DATE_RANGE.CUSTOM) {
        let fromDateArr = [];
        let toDateArr = [];
        if (this.props.chartOptions.fromDate) {
          fromDateArr = this.props.chartOptions.fromDate.split('/');
        } else {
          alert('Please select from Date');
          return false;
        }
        if (this.props.chartOptions.toDate && this.props.chartOptions.toDate.length > 0) {
          toDateArr = this.props.chartOptions.toDate.split('/');
        }
        let fromDate;

        // let fromDate = new Date(fromDateArr[2], fromDateArr[0], fromDateArr[1]).toISOString();
        if (fromDateArr.length > 1) {
          fromDate = new Date(fromDateArr[2] + '-' + fromDateArr[0] + '-' + fromDateArr[1]).toISOString();
        } else {
          fromDate = fromDateArr[0];
        }

        let toDate = '';
        if (toDateArr.length > 0) {
          let _toDate;
          // toDate = new Date(toDateArr[2], toDateArr[0], toDateArr[1]).toISOString();
          toDate = new Date(toDateArr[0] + '-' + toDateArr[1] + '-' + toDateArr[2]).toISOString();
          _toDate = toDate.split('T');
          _toDate.splice(1,1,constants.DATE_TIMESTAMP.lastHour);
          toDate = _toDate.join('T');
        } else {
          toDate = new Date().toISOString();
          let defaultToDate = (new Date().getMonth()+1)+'/' + new Date().getDate() + '/'+new Date().getFullYear();
          this.props.dispatch(updateToDate(defaultToDate));
        }
        this.props.dispatch(loadChartData(this.props.selectedTwig.twigId, fromDate, toDate, '', twigIndx));
      } else {
        let dates;
        if (this.refs.dateRange.value == constants.DATE_RANGE.ALL) {
          this.props.dispatch(updateFromDate(''));
          this.props.dispatch(updateToDate(''));
          dates = {
            fromDate: '',
            toDate: ''
          }
        } else {
          dates = getDateFromDateRange(this.refs.dateRange.value);

          this.props.dispatch(updateFromDate(new Date(dates.fromDate)));
          this.props.dispatch(updateToDate(new Date(dates.toDate)));
        }
        let fromDate = '';
        let toDate = new Date();
        let toDateUTC = toDate.toISOString();
        if (dates.fromDate != '') {
          fromDate = new Date(dates.fromDate).toISOString();
        }
        this.props.dispatch(loadChartData(this.props.selectedTwig.twigId, fromDate, toDateUTC, '', twigIndx));
      }
    }, timeOutValue)


  }
  _selectTwig(e) {
    let index = e.target.value;
    this.props.twigsList[index].twigId;
    let fromDate = new Date(this.props.chartOptions.fromDate).getTime();
    let toDate = new Date(this.props.chartOptions.toDate).getTime();
    // this.props.dispatch(updateSelectedTwig(index));

  }
  clearDateRange(dateRange) {
    if (constants.DATE_RANGE.CUSTOM === dateRange.Type) {
        dateRange.FromDate = '';
        dateRange.ToDate = '';
    }
    this.props.dispatch(updateFromDate(''));
    this.props.dispatch(updateToDate(''));
    return dateRange;
  }
  _dateRangeSelectChange(e) {
    let dateRange = this.state.dateRange;
    dateRange.Type = e.target.value;
    dateRange = this.clearDateRange(dateRange);
    setTimeout(
      function(eValue,scope){
        scope.props.dispatch(updateDateRange(eValue))
      },5,e.target.value,this
    );
    //this.props.dispatch(updateDateRange(e.target.value))
    this.setState({
      dateRangeValue: e.target.value,
      dateRange: dateRange
    });
    
    
    
    // this.props.dispatch(changeResolution(e.target.value));
  }

  getUserPreference() {
    this.props.dispatch(getUserPreferencesAction());
  }

  onTwigChange(e) {
    this.setState({ chosenTwig: e.target.value });
  }

  onDateRangeChange(e) {
    let dateRange = { Type: constants.DATE_RANGE.ALL, FromDate: '', ToDate: '' };
    dateRange.Type = e.target.value;

  }

  setControlData() {
    let controlData = {
      twigIndex: 0, dateRange: constants.DATE_RANGE.ONE_WEEK,
      fromDate: '', toDate: ''
    };
    if (this.state.chosenTwig === '-1') {
      controlData.twigIndex = this.props.selectedTwigIndex;
    } else {
      controlData.twigIndex = this.state.chosenTwig
    }

    if (this.state.dateRange.FromDate != 'empty') {
      controlData.fromDate = this.state.dateRange.FromDate;
    } else {
      controlData.fromDate = this.props.chartOptions.fromDate
    }

    if (this.state.dateRange.ToDate != 'empty') {
      controlData.toDate = this.state.dateRange.ToDate;
    } else {
      controlData.toDate = this.props.chartOptions.toDate;
    }

    if (this.state.dateRange.Type != constants.DATE_RANGE.NONE) {
      controlData.dateRange = this.state.dateRange.Type;
    } else {
      controlData.dateRange = this.props.chartOptions.dateRange;
    }
    return controlData;
  }

  showSideMenu(){
    return !this.props.showStripePlans ? <SideMenu /> : '';
  }

  _onResponsive(responsive) {
    if (responsive === 'multiple') {
      this.setState({ showLayer: false });  
    }
  }

  render() {
    const {
      nav: { active: navActive, enabled: navEnabled, responsive }
    } = this.props;
    const { showLayer }  = this.state;

    let font12 = {
      fontSize: '12px'
    }
    let font14 = {
      fontSize: '14px'
    }


    let twigIndex = 0;
    if (this.state.chosenTwig === '-1') {
      twigIndex = this.props.selectedTwigIndex;
    } else {
      twigIndex = this.state.chosenTwig
    }

    let controlData=this.setControlData();

    const content = (
      this.showSideMenu()
    );
    let leftNode;
    let buttonNode;
    let layerNode;

    if (responsive === 'multiple' && !navEnabled) {
      leftNode = (
        <Sidebar colorIndex="neutral-1" fixed={true}>
          {content}
        </Sidebar>
      );   
    } else if (showLayer) {
      layerNode = (
        <Layer
          flush={true}
          colorIndex="neutral-1"
          fixed={true}
          className="charts-tab-left-menu"
          closer={true}
          onClose={() => this.setState({ showLayer: false })}
          peek={true}
        >
          {content}
        </Layer>
      );       
    } else if(responsive === 'single' && !navEnabled) {
      buttonNode = (
        <Button icon={<MenuIcon />} style={{float: 'right'}} onClick={() => this.setState({ showLayer: true })} />  
      )
    }

    return (
      <Split flex="right" className="location-view" onResponsive={this._onResponsive}>
        {leftNode}
        {buttonNode}
        <Article>

          <Header className="stemdetails-section" size='large' pad={{ between: 'small', horizontal: 'small' }} direction={this.state.directionForHeader}>
            {/*<NavControl />*/}

            <FormField label="Choose Stem">
              <select ref='selectedTwigIndex' className="font12" onChange={this.onTwigChange} value={controlData.twigIndex}>
                {
                  this.props.twigsList.map((item, index) => {
                    return (
                      <option key={index} value={index}>{(item.name ?item.name + '@' : '-@') + (item.locationName ? item.locationName : '-') + ' (' + item.twigId + ')'}</option>
                    )
                  })
                }
              </select>
            </FormField>
            <FormField label="Date Range" >
              <select ref='dateRange' onChange={this._dateRangeSelectChange} className="font12" value={controlData.dateRange} disabled = {this.props.showStripePlans}>
                <option value={constants.DATE_RANGE.ALL}>All</option>
                <option value={constants.DATE_RANGE.ONE_WEEK}>1 Week</option>
                <option value={constants.DATE_RANGE.TWO_WEEKS}>2 Weeks</option>
                <option value={constants.DATE_RANGE.ONE_MONTH}>1 Month</option>
                <option value={constants.DATE_RANGE.SIX_MONTHS}>6 Months</option>
                <option value={constants.DATE_RANGE.ONE_YEAR}>1 Year</option>
                <option value={constants.DATE_RANGE.CUSTOM}>Custom</option>
              </select>

            </FormField>
            {/*<span>Date Range</span>*/}

            <FormField label="From" className={controlData.dateRange == constants.DATE_RANGE.CUSTOM ? 'show' : 'hide'}>
              <DateTime id='id'
                name='name'
                value={
                  convertDate(controlData.fromDate)
                }
                format='MM/DD/YYYY'
                onChange={this._onStartDateChange} />
            </FormField>

            <FormField label="To" className={controlData.dateRange == constants.DATE_RANGE.CUSTOM ? 'show' : 'hide'}>
              <DateTime id='id'
                name='name'
                value={convertDate(controlData.toDate)}
                format='MM/DD/YYYY'
                onChange={this._onToDateChange} />
            </FormField>

            {/*<FormField label="Resolution">
              <select onChange={this._onResolutionChange}>
                <option value="1">1 min</option>
                <option value="5">5 min</option>
                <option value="15">15 min</option>
                <option value="30">30 min</option>
              </select>
            </FormField>*/}
            <Button label='Update Chart'
              className='lighter-font'
              onClick={this._updateChart}
              primary={true}
              secondary={false}
              accent={false} />

          </Header>
          {this._manageLocationView()}
          {/* <Plans/>
          <ChartView /> */}
        </Article>
        {layerNode}
      </Split >

    );
  }

}

LocationView.propTypes = {
  twigsList: PropTypes.array,
  search: PropTypes.object
};

let select = (state, props) => ({
  twigsList: state.locationView.twigsList,
  selectedTwig: state.locationView.selectedTwig,
  selectedTwigIndex: state.locationView.selectedTwigIndex,
  chartData: state.locationView.chartData,
  chartOptions: state.locationView.chartOptions,
  search: state.search,
  showChart: state.locationView.showChart,
  showRawGraph: state.locationView.showRawGraph,
  showTrendLine: state.locationView.showTrendLine,
  trendAverage: state.locationView.trendAverage,
  showUpperLimit: state.locationView.showUpperLimit,
  showLowerLimit: state.locationView.showLowerLimit,
  userPreferences: state.locationView.userPreferences,
  zoom: state.locationView.zoom,
  stripePlans : state.locationView.stripePlans,
  showStripePlans : state.locationView.showStripePlans,
  addSubscription: state.subscriptionView.addSubscription,
  stripeAPIKey : state.session.stripeAPIKey,
  nav: state.nav,
});

export default connect(select)(LocationView);



// WEBPACK FOOTER //
// ./src/js/components/location/LocationView.js